export default "__VITE_ASSET__Doydvm3$__"